import { ID } from '..';
import { ListOptions } from '../../interfaces/options';
import { SelectionMode, EditableType } from '../../enums';
import { ListProperty } from '../../models';

// TODO: Revise, no idea how to pass a type in interface implementation
export const DefaultListOptions: ListOptions<any> = {
	dataSource: {
		paging: true
	},
	selectionMode: SelectionMode.MULTIPLE,
	// wouldn't build without <any>
	//propertyModel: ListProperty,
	propertyModel: <any>ListProperty,
	idProperty: ID.ID,
	confirmBeforeDelete: true,
	editable: EditableType.ALL
};
